export type WizardConfigName =
  | 'JAVA'
  | 'DOTNET'
  | 'DOTNET_CORE'
  | 'NODE'
  | 'RUBY'
  | 'PYTHON'
  | 'PHP'
  | 'PROXY'
  | 'GO'
  | 'UNIVERSAL'

export const WizardConfigNames: WizardConfigName[] = [
  'JAVA',
  'DOTNET',
  'DOTNET_CORE',
  'NODE',
  'RUBY',
  'PYTHON',
  'PHP',
  'PROXY',
  'GO',
  'UNIVERSAL'
]

export type WizardAgent =
  | 'JAVA'
  | 'DOTNET'
  | 'DOTNET_CORE'
  | 'NODE'
  | 'RUBY'
  | 'PYTHON'
  | 'PHP'
  | 'PROXY'
  | 'GO'
  | 'UNIVERSAL'

export const WizardAgents: WizardAgent[] = [
  'JAVA',
  'DOTNET',
  'DOTNET_CORE',
  'NODE',
  'RUBY',
  'PYTHON',
  'PHP',
  'PROXY',
  'GO',
  'UNIVERSAL'
]

export type WizardStep =
  | 'download'
  | 'configure'
  | 'install'
  | 'restart'
  | 'connection'
  | 'running'

export interface WizardConfig {
  readonly agent: WizardAgent
  readonly steps: WizardStep[]
}

export const wizardConfigs: Record<WizardConfigName, WizardConfig> = {
  JAVA: {
    agent: 'JAVA',
    steps: ['download']
  },
  DOTNET: {
    agent: 'DOTNET',
    steps: ['download', 'configure', 'install', 'restart', 'connection']
  },
  DOTNET_CORE: {
    agent: 'DOTNET_CORE',
    steps: ['download']
  },
  NODE: {
    agent: 'NODE',
    steps: ['download']
  },
  RUBY: {
    agent: 'RUBY',
    steps: ['download']
  },
  PYTHON: {
    agent: 'PYTHON',
    steps: ['download']
  },
  PHP: {
    agent: 'PHP',
    steps: ['download']
  },
  PROXY: {
    agent: 'PROXY',
    steps: ['download', 'install', 'configure', 'restart']
  },
  GO: {
    agent: 'GO',
    steps: ['download']
  },
  UNIVERSAL: {
    agent: 'UNIVERSAL',
    steps: ['download']
  }
}
